(function($){
 
	$(document).ready(function() {

		/* ---------------------------------------------- /*
		 * Smooth scroll / Scroll To Top
		/* ---------------------------------------------- */

		$('.scroll-up a').bind("click", function(e){
           
			var anchor = $(this);
			$('html, body').stop().animate({
				scrollTop: $(anchor.attr('href')).offset().top
			}, 1000);
			e.preventDefault();
		});

		$(window).scroll(function() {
			if ($(this).scrollTop() > 100) {
				$('.scroll-up').fadeIn();
			} else {
				$('.scroll-up').fadeOut();
			}
		});

		/* ---------------------------------------------- /*
		 * Navbar
		/* ---------------------------------------------- */

		$('.header').sticky({
			topSpacing: 0
		});

		$('body').scrollspy({
			target: '.navbar-custom',
			offset: 0
		})

        
		/* ---------------------------------------------- /*
		 * Home BG
		/* ---------------------------------------------- */

		$(".screen-height").height($(window).height());

		$(window).resize(function(){
			$(".screen-height").height($(window).height());
		});

		if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
			$('#home').css({'background-attachment': 'scroll'});
		} else {
			 
		}

 
		

	});
  
  /* ==============================================
		owl-carousel hide imgs on load
	=============================================== */
	if ($('.owl-carousel').length > 0){//display if exist on the page
      $('.owl-carousel').owlCarousel({
        loop: true,
        items:1,
        nav: true,
        navText : [ '<span class="fa fa-chevron-left"></span>', '<span class="fa fa-chevron-right"></span>' ],

      });	
    }
  
  /* -------------------------------------------------- /*
	 * AddBootstrap carousel swip 
	 * Display only if class .carousel exist in the page
	/* -------------------------------------------------- */

	if($(".carousel").length > 0) {//display if exist on the page
	 	$(".carousel").swipe({

		  swipe: function(event, direction, distance, duration, fingerCount, fingerData) {

		    if (direction == 'left') $(this).carousel('next');
		    if (direction == 'right') $(this).carousel('prev');

		  },
		  allowPageScroll:"vertical"

		});
	}

})(jQuery);



	 /* ---------------------------------------------- /*
	 * Create hash # link to Modal when click
	 * Triger bootstrap modal and add hash # to Url
	/* ---------------------------------------------- */
	  $(function(){
	      if(window.location.hash) {
	          var hash = window.location.hash;
	          $(hash).modal('toggle');
	      }
	  });

	

	/* ==============================================
		MENU COLLAPSE WHEN CLICK LINK NAV
	=============================================== */
	$(document).on('click','.navbar-collapse.in',function(e) {
	    if( $(e.target).is('a') && $(e.target).attr('class') != 'dropdown-toggle' ) {
	        $(this).collapse('hide');
	    }
	});

	

	/* ==============================================
	VALIDATION CONTACT FORM SCROLL
	=============================================== */
	 $(document).ready(function() {
	 	if($(".contactUs").length > 0) {
	        $(".sendMes").click(function() {
	          $('html, body').animate({
	              scrollTop: $(".contactUs").offset().top
	          }, 500);
	        });
	    }
    });

 
